<template>
  <div class="page-content">
    <Header />
    <div class="header-menu">
      <el-button type="primary" size="large" @click="handleBack"
        >返回工作台</el-button
      >
    </div>
    <el-table
      :data="tableData"
      style="margin: 20px 10px; width: calc(100% - 20px)"
      height="calc(100% - 120px)"
    >
      <el-table-column label="序号" type="index" width="80" align="center">
      </el-table-column>
      <el-table-column prop="userNickName" label="用户昵称" align="center">
      </el-table-column>
      <el-table-column prop="operMethod" label="调用方法" align="center">
      </el-table-column>
      <el-table-column prop="ip" label="IP地址" align="center">
      </el-table-column>
      <el-table-column
        prop="description"
        label="描述"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="操作时间"
        align="center"
        width="220"
      >
        <template slot-scope="scope">
          {{ formatTime(scope.row.createTime) }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next"
      :total="totalCount"
      style="margin: 20px 10px; text-align: right"
    >
    </el-pagination>
  </div>
</template>

<script>
import Header from "./Header.vue";
import dayjs from "dayjs";
import { getOperationLogPage } from "@/api/workbench";
export default {
  name: "ActionLog",
  components: {
    Header,
  },
  data() {
    return {
      tableData: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const res = await getOperationLogPage({
          page: this.page,
          pageSize: this.pageSize,
        });
        if (res.code === 200 && res.data) {
          this.tableData = res.data.list || [];
          this.totalCount = parseInt(res.data.totalCount) || 0;
        }
      } catch (error) {
        console.error("获取操作日志失败:", error);
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    handleBack() {
      this.$router.push({ path: "/workbench" });
    },
    formatTime(time) {
      if (!time) return "--";
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>

<style lang="less" scoped>
.page-content {
  height: 70vh;
}
.header-menu {
  width: 100vw;
  display: flex;
  padding-right: 30px;
  justify-content: flex-end;
}
.permission-dialog {
  :deep(.el-dialog) {
    margin-top: 15vh !important;

    .el-dialog__body {
      height: 50vh;
      padding: 10px 20px;
    }
  }
}

.permission-tree {
  height: 100%;
  overflow-y: auto;

  .el-checkbox {
    margin-bottom: 15px;
  }

  .menu-list {
    .menu-card {
      margin-bottom: 15px;

      .card-header {
        padding: 0;
        border-bottom: none;
      }

      :deep(.el-card__header) {
        padding: 10px 15px;
      }

      :deep(.el-card__body) {
        padding: 10px 15px;
      }

      .tree-container {
        margin-top: 10px;

        .el-tree {
          background: none;

          :deep(.el-tree-node__content) {
            height: 32px;
            line-height: 32px;
          }

          :deep(.el-tree-node__label) {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
